/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Context_ClampedInputs */



/**
* | output |
* | --- |
* | "The context window is above 1,000,000 tokens and will be used as 1,000,000." |
*
* @param {Private_Models_Hint_Context_ClampedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_context_clamped = /** @type {((inputs?: Private_Models_Hint_Context_ClampedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Context_ClampedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Kontextfenster liegt über 1.000.000 Tokens und wird mit 1.000.000 verwendet.")
	return /** @type {LocalizedString} */ ("The context window is above 1,000,000 tokens and will be used as 1,000,000.")
});